import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import I18n from '../../../config/i18n';

import './langswitch.css';

const urlLangPart = new RegExp(`/(${I18n.supportedLocales.join('|')})/?`);
const trailingSlash = /\/$/;

export default function Langswitch(): JSX.Element {
  const location = useLocation();
  const path = location.pathname + location.search;

  return (
    <ul className="langswitch">
      {(I18n.supportedLocales as string[]).map((lang) => (
        <li
          key={lang}
          className={classNames('langswitch-item', {
            active: lang === I18n.locale,
          })}
        >
          <Link to={path.replace(urlLangPart, `/${lang}/`).replace(trailingSlash, '')}>
            {lang.toUpperCase()}
          </Link>
        </li>
      ))}
    </ul>
  );
}
